// List of allowed "rel" attributes that can appear multiple times in the <head> tag
export const ALLOWED_MULTIPLE_REL_VALUES: string[] = [
  'stylesheet', // Multiple stylesheets can be included
  'dns-prefetch', // Multiple DNS prefetch links are allowed
  'preconnect', // Multiple preconnect links for different origins are allowed
  'prefetch', // Multiple prefetch links for resources are allowed
  'preload', // Multiple preload links are used for various resources
  'alternate', // Multiple alternates for different languages, formats, etc.
  'icon', // Multiple icons for different sizes/formats are valid
  'apple-touch-icon', // Multiple Apple touch icons for different resolutions
  'manifest', // Web app manifest link
];

export const isRelAllowedMultipleTimes = (rel: string): boolean => ALLOWED_MULTIPLE_REL_VALUES.includes(rel);
